import React from 'react';
import type { AthleteProps, BestAvailableOrderProps, EventProps, ExternalPriceProps, FundOrderProps, FundProps, LeagueProps, MarketProps, MatchProps, OrderProps, SortedContestProps, TournamentProps, TradeProps } from "../../types"
import Contest from './Contest';
import { MarketMaketHelpers } from '../api';
import FundActions from './FundActions';
import { Text, View } from '../../Components/Themed';
import { FlatList } from 'react-native';

type DashboardProps = {
    loaded:boolean,
    fund?:FundProps,
    leagues:LeagueProps[],
    events:EventProps[],
    markets:MarketProps[],
    tournaments:TournamentProps[],
    matches:MatchProps[],
    best_available_orders:BestAvailableOrderProps[],
    trades:TradeProps[],
    prices:ExternalPriceProps[],
    orders:OrderProps[],
    fund_orders:FundOrderProps[],
    athletes:AthleteProps[],
    external_name?:string,
    onSetMarket:(orders:OrderProps[], market:MarketProps, prices:ExternalPriceProps[]) => void,
    onClearMarket:(order_ids:string[]) => void,
    onWorkCapital:(amount:number) => void,
    onLayoffCapital: (amount: number) => void,
    onDepositFund: (amount:number) => void,
    onOrder:(order:OrderProps, available?:number) => void
}


const Dashboard = ({ fund, external_name, athletes, prices, leagues, events, tournaments, matches, markets, orders, fund_orders, best_available_orders, trades, onOrder, onSetMarket, onClearMarket, onWorkCapital, onLayoffCapital, onDepositFund }:DashboardProps) => {
    const contests = MarketMaketHelpers.sortContests(events, tournaments, matches, markets)
    
    const renderContests = (data:{item:SortedContestProps, index:number}) => {
        if(!fund){ return <></> }
        const league = leagues.find(l => l.league_id == data.item.league_id)
        const contest_orders = orders.filter(o => o.event_type == data.item.contest_type && o.event_id == data.item.id);
        const contest_fund_orders = fund_orders.filter(fo => contest_orders.map(o => o.order_id.toString()).includes(fo.order_id.toString()));
        const contest_trades = trades.filter(t => t.event_type == data.item.contest_type && t.event_id == data.item.id);
        const contest_ba = best_available_orders.filter(o => o.event_type == data.item.contest_type && o.event_id == data.item.id);
        
        const event = events.find(e => e.event_id == data.item.id && data.item.contest_type == 'team');
        const tournament = tournaments.find(t => t.tournament_id == data.item.id && data.item.contest_type == 'tournament');
        const match = matches.find(m => m.match_id == data.item.id && data.item.contest_type == 'match');
        const contest_prices = prices.filter(p => p.event_type == data.item.contest_type && p.event_id == data.item.id);
        const book_prices = contest_prices.filter(p => p.external_name == external_name)
        return (
            <View key={`${data.item.contest_type}${data.item.id}`}>
                <Contest
                    contest_id={data.item.id}
                    contest_type={data.item.contest_type}
                    time_detail={data.item.time_detail}
                    league={league}
                    event={event}
                    athletes={athletes}
                    tournament={tournament}
                    match={match}
                    init_show_detail={data.index == 0 ? true : false}
                    fund={fund}
                    contest_title={data.item.title}
                    latest_trades={contest_trades}
                    best_available_orders={contest_ba}
                    external_prices={book_prices}
                    backup_prices={contest_prices}
                    orders={contest_orders}
                    fund_orders={contest_fund_orders}
                    onSetMarket={onSetMarket}
                    onClearMarket={onClearMarket}
                    onOrder={onOrder}
                    markets={data.item.markets}
                />
            </View>
        )
    }

    return (
        <View>
            <View type='header' style={{ flexDirection:'row', alignItems:'center' }}>
                <View style={{ flex:1 }}>
                    <Text theme='h1'>Dashboard</Text>
                    <Text style={{ marginTop:3 }} theme='description'>Select contests and markets to see activity and market options</Text>
                </View>
            </View>
            {fund?
            <FundActions
                fund={fund}
                onDepositFund={onDepositFund}
                onLayoffCapital={onLayoffCapital}
                onWorkCapital={onWorkCapital}
                onReleaseFunds={() => console.log('WITDHRAW!!!')}
            />
            :<></>}
            <FlatList
                data={contests.sort((a,b) => a.scheduled_datetime.unix() - b.scheduled_datetime.unix())}
                keyExtractor={(item) => item.id}
                renderItem={renderContests}
            />
        </View>
    )
}

export default Dashboard